module.exports = __webpack_public_path__ + "static/media/PowerButtonHover.93e4360c.svg";